import React, { useEffect, useState } from "react";
import { Topbar, Alert } from "@components";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  InfoBox,
  InfoBoxWrapper,
  RootContainer,
  ButtonWrapper,
  SpinWrapper,
  Image,
  ImageBox,
  Text,
  Title,
  EmptyCard,
  SelectAccountTitle,
} from "./WithdrawAccounts.style";
import { Button, Radio, Spin } from "antd";
import TermsConditions from "../TermsConditions/TermsConditions";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "@router/route.constants";
import { WITHDRAW_LK, UPDATE_MODE_LK } from "@constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";
import { AccountEmptyFill } from "@assets";
import { EditFill, AddFill } from "@assets";
import { setHasWithdrawAccount, openAlert } from "@redux/app/appSlice";

const WithdrawAccounts = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  // handle existing multiple old accounts
  const [isMultiple, setIsMultiple] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectLoading, setSelectLoading] = useState(false);

  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const { withdraw_rule } = useSelector((state) => state.app.settings);

  const withdrawRule =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? withdraw_rule?.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? withdraw_rule?.text_mm
        : withdraw_rule?.text_ch;

  useEffect(() => {
    getUserPayments();
    getUserPaymentCategories();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsMultiple(data.length > 1);

    // eslint-disable-next-line
  }, [data]);

  const getUserPayments = () => {
    setLoading(true);
    api
      .getUserPayments()
      .then(({ user_payments }) => {
        setLoading(false);
        setData(user_payments);
        dispatch(setHasWithdrawAccount(user_payments.length > 0));
      })
      .catch(() => { });
  };

  const getUserPaymentCategories = () => {
    api
      .getUserPaymentCategories()
      .then(({ payment_categories }) => {
        setHasMore(payment_categories.length > 0);
      })
      .catch(() => { });
  };

  const handleSelectClicked = () => {
    if (!selectLoading) {
      setSelectLoading(true);
      api
        .chooseUserPayment({
          user_payment_id: selectedItem.user_payment_id
        })
        .then(() => {
          setSelectLoading(false);
          showAlert({
            message: t("wallet.selectAccSuccessMsg"),
            successCallback: () => {
              setData([selectedItem]);
              setSelectedItem(null);
            }
          });
        })
        .catch((errorMsg) => {
          setSelectLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  }

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    if (state?.isSpin) {
      navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
      return;
    }
    if (state?.isNoti) {
      navigate(`/${PUBLIC_ROUTE.NOTIFICATION}`);
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`);
  };

  const handleNewClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${WITHDRAW_LK}`);
  };

  const handleItemClicked = (item) => {
    if (isMultiple) {
      setSelectedItem(item);
      return;
    }
    navigate(`/${PRIVATE_ROUTE.CONFIRM_PIN}`, { state: item });
  };

  const handleEditClicked = (item) => {
    navigate(`/${PRIVATE_ROUTE.CREATE_UPDATE_ACCOUNT}/${UPDATE_MODE_LK}`, {
      state: { item },
    });
  };

  const Item = ({ item }) => (
    <Box>
      <ImageBox onClick={() => handleItemClicked(item)}>
        <Image src={item.payment_category_image} />
      </ImageBox>
      <InfoBoxWrapper onClick={() => handleItemClicked(item)}>
        <InfoBox>
          <Text>{item.name}</Text>
          <Title>{item.num}</Title>
        </InfoBox>
      </InfoBoxWrapper>
      {isMultiple && <Radio onClick={() => handleItemClicked(item)} checked={selectedItem?.user_payment_id === item.user_payment_id} />}
      {!isMultiple && <EditFill onClick={() => handleEditClicked(item)} />}
    </Box>
  );

  const Empty = () => (
    <EmptyCard>
      <AccountEmptyFill />
      <Title>{t("wallet.withdrawAccountNoList")}</Title>
    </EmptyCard>
  );

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  return (
    <>
      <Topbar title={t("wallet.walletWithdraw")} goBack={goBack} />
      {loading && <Loader />}
      {!loading && (
        <RootContainer>
          {data.length === 0 && <Empty />}
          {isMultiple && <SelectAccountTitle style={{ paddingBottom: '16px' }}>*{t("wallet.multipleAccInfoLabel")}*</SelectAccountTitle>}
          {data.map((item, key) => (
            <Item key={key} item={item} />
          ))}
          <ButtonWrapper>
            {data.length === 0 &&
              <Button onClick={handleNewClicked} disabled={!hasMore}>
                {t("wallet.withdrawAccountAdd")}
                <AddFill />
              </Button>
            }
            {isMultiple &&
              <Button
                type="primary"
                onClick={handleSelectClicked}
                disabled={!selectedItem}
                loading={selectLoading}
              >
                {t("wallet.selectWithdrawAccBtnLabel")}
              </Button>
            }
          </ButtonWrapper>
          <TermsConditions
            title={t("wallet.walletWithdraw")}
            rule={withdrawRule}
          />
        </RootContainer>
      )}
      <Alert />
    </>
  );
};

export default WithdrawAccounts;
